
// epoch
document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.timeline-item__heading');
  const options = {
    root: null,
    rootMargin: '-10% 0px -10% 0px',
    threshold: 0.2
  };
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
        observer.unobserve(entry.target);
      }
    });
  }, options);
  targets.forEach(target => observer.observe(target));
});


// line
gsap.registerPlugin(ScrollTrigger);

gsap.to('.timeline-line__inner', {
  scaleY: 1,
  ease: 'none',
  scrollTrigger: {
    trigger: '.timeline',
    start: 'top 40%',
    end: 'bottom 80%',
    scrub: true
  }
});